import { render, staticRenderFns } from "./BullsLIstPage.vue?vue&type=template&id=3d520a72&scoped=true&"
import script from "./BullsLIstPage.vue?vue&type=script&lang=js&"
export * from "./BullsLIstPage.vue?vue&type=script&lang=js&"
import style0 from "./BullsLIstPage.vue?vue&type=style&index=0&id=3d520a72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d520a72",
  null
  
)

export default component.exports